export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const REPLACE_INTEGRATION = 'REPLACE_INTEGRATION';
export const REMOVE_INTEGRATION = 'REMOVE_INTEGRATION';